import { render } from "./widget-1.vue?vue&type=template&id=2aa12798"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/widgets/widget-1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2aa12798"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2aa12798', __exports__)) {
    api.reload('2aa12798', __exports__)
  }
  
  module.hot.accept("./widget-1.vue?vue&type=template&id=2aa12798", () => {
    api.rerender('2aa12798', render)
  })

}


export default __exports__